module.exports = __webpack_public_path__ + "static/media/bieu_mau_03_lay_y_kien_gv_trong_truong.8f1b0750.xlsx";